export enum AuditReason {
  Created,
  Updated,
  Approved,
  Rejected,
  Canceled
}
